module.exports = __webpack_public_path__ + "img/shipo-sales-plan-arrow-up.3ef91c05.svg";